import React from "react";

import LeftTimer from "./LeftTimer";
import MainTimerDisplay from "./MainTimerDisplay";
import OnAddEventNotes from "./OnAddEventsNotes";
import PenaltyGoalButtons from "../PenaltyGoalButtons/PenaltyGoalButtons";
import StartStopButton from "./StartStopButton";

import styles from "./main-timer-display.module.scss";

const MainTimers = ({
    quarterSelected,
    timerSecondsSelected,
    setTimerSecondsSelected,
    setTimersPerQuarter,
    quarterParams,
    isLiveTickerStaff,
    TOTAL_TIME_PLAYED,
    setEventDetailsToAdd,
    EVENT_TYPES,
    setIsModalOpen,
    sides,
    goals,
    setGoals,
    setIsEditing,
    setComponentToInsertInModal,
    matchId,
    setMatchStatus,
    matchStatus,
    matchData,
    setMatchData,
    formatApiData,
    setEventsToShow,
    homePlayers,
    awayPlayers
  }) => {
      const { quarter4, matchHasShootout, matchPosts} = matchData;
      const penaltyEvent = matchPosts?.some(post => post.additionalData === 'Start of a shootout');
      const isShootout = quarter4 && matchHasShootout && penaltyEvent;
      const penaltyShootActive = matchData.matchPosts?.length ? matchData.matchPosts[matchData.matchPosts.length -1].postType === 32 : false;
    return (
      <div
        className={styles['timers']}
        style={{
          ...(isShootout ? {justifyContent: 'center'} : {})
        }}
      >
          {!isShootout ? (
              <LeftTimer
              quarterParams={quarterParams}
              timerSecondsSelected={timerSecondsSelected}
              setTimerSecondsSelected={setTimerSecondsSelected}
              setTimersPerQuarter={setTimersPerQuarter}
              matchId={matchId}
              matchData={matchData}
              setMatchData={setMatchData}
              matchStatus={matchStatus}
              />
          ) : null}
          {!isShootout ? (
              <MainTimerDisplay quarterParams={quarterParams} />
          ) : <PenaltyGoalButtons
              penaltyShootActive={penaltyShootActive}
              matchData={matchData}
              matchId={matchId}
              setMatchData={setMatchData}
              formatApiData={formatApiData}
              sides={sides}
              setEventsToShow={setEventsToShow}
              homePlayers={homePlayers}
              awayPlayers={awayPlayers}
              />
          }
        {isLiveTickerStaff ? (
          <OnAddEventNotes
            quarterParams={quarterParams}
            setTimersPerQuarter={setTimersPerQuarter}
            TOTAL_TIME_PLAYED={TOTAL_TIME_PLAYED}
            quarterSelected={quarterSelected}
            setEventDetailsToAdd={setEventDetailsToAdd}
            EVENT_TYPES={EVENT_TYPES}
            setIsModalOpen={setIsModalOpen}
            sideSelected={sides["home"]}
            sideNotSelected={sides["away"]}
            sides={sides}
            backgroundColor="#D2E5DB"
            direction="row"
            goals={goals}
            setGoals={setGoals}
            setIsEditing={setIsEditing}
            setComponentToInsertInModal={setComponentToInsertInModal}
          />
        ) : (
          <StartStopButton
            quarterParams={quarterParams}
            setTimersPerQuarter={setTimersPerQuarter}
            matchId={matchId}
            setMatchStatus={setMatchStatus}
            matchStatus={matchStatus}
            matchData={matchData}
            setMatchData={setMatchData}
            totalTimePlayed={TOTAL_TIME_PLAYED}
            formatApiData={formatApiData}
            setEventsToShow={setEventsToShow}
            homePlayers={homePlayers}
            awayPlayers={awayPlayers}
            sides={sides}
          />
        )}
      </div>
    );
};

export default MainTimers;